import { mediaMixin, spaceMixin, spacingMixin } from '@zillow/constellation';

import { css } from 'styled-components';

export default (props) =>
  props.theme &&
  props.theme.ns &&
  css`
    && {
      ${mediaMixin(
        'xs',
        css`
          margin-left: 0 !important;
          margin-right: 0 !important;
        `,
      )}
      ${mediaMixin(
        'lg',
        css`
          margin-left: -${spaceMixin('xs')} !important;
          margin-right: -${spaceMixin('xs')} !important;
        `,
      )}

            ${mediaMixin(
        'xl',
        css`
          margin-left: -${spaceMixin(1.5)} !important;
          margin-right: -${spaceMixin(1.5)} !important;
        `,
      )}

            ${props.noMargin &&
      css`
        & {
          margin: 0 !important;
        }
      `}

            & {
        ${spacingMixin};
      }
    }
  `;
